export default {
  about: (state) => state.about,
};
